import {
  GET_COMMUNITY_CHAT,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
  SET_ORDER_BY,
  SET_SORT_BY,
} from "../../shared/constants/ActionTypes";

const initialTestimonial = {
  eh_comment: [],
  commentCount: 0,
  page: 1,
  search: "",
  courseId: "",
  sortby: "",
  orderby: "desc",
};

const communityReducer = (state = initialTestimonial, action) => {
  switch (action.type) {
    case GET_COMMUNITY_CHAT:
      return {
        ...state,
        eh_comment: action.payload.chat.map((test) => {
          return {
            ...test,
            name: test.student
              ? test.student.firstName + " " + test.student.lastName
              : test.tutor?.firstName + " " + test.tutor?.lastName,
          };
        }),
        commentCount: action.payload.total,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
};

export default communityReducer;
